import type { TAnswers, TQuizAnswer } from 'models/common.model'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface IGlobalSessionStore {
  isStepBack?: boolean
  isFirstPageLoad?: boolean
  accountEmail: string
  language: string
  userName: string
  userAnswers: TAnswers | TQuizAnswer | null // only for local use, for common use get from lead
  certificateId: string | null
  certificateIssuedAt: string | null
}

const INITIAL_SESSION_STORE: IGlobalSessionStore = {
  accountEmail: '',
  isStepBack: false,
  isFirstPageLoad: false,
  language: '',
  userName: '',
  userAnswers: null,
  certificateId: null,
  certificateIssuedAt: null,
}

export const useZustandSessionStore = create<IGlobalSessionStore>()(
  persist(() => INITIAL_SESSION_STORE, {
    name: 'session-data-storage',
    storage: createJSONStorage(() => sessionStorage),
  }),
)
export const useZustandGlobalSessionStore = useZustandSessionStore
